
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./Join.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Join = () => {
  const [slidesToShow, setSlidesToShow] = useState(4);

  const updateSlidesToShow = () => {
    if (window.innerWidth <= 425) {
      setSlidesToShow(1);
    } else if (window.innerWidth <= 768) {
      setSlidesToShow(2);
    } else if (window.innerWidth <= 1024) {
      setSlidesToShow(3);
    } else {
      setSlidesToShow(4);
    }
  };

  useEffect(() => {
    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const data = [
    {
      id: 1,
      img: require("../../Assets/img8.png"),
      title: "Certified Nurses & Caregivers",
    },
    { id: 2, img: require("../../Assets/img9.png"), title: "Physiotherapists" },
    {
      id: 3,
      img: require("../../Assets/img10.png"),
      title: "Doctors & Specialists",
    },
    {
      id: 4,
      img: require("../../Assets/img11.png"),
      title: "Baby Care Professionals",
    },
    { id: 5, img: require("../../Assets/img8.png"), title: "Nutritionists" },
    { id: 6, img: require("../../Assets/img9.png"), title: "Therapists" },
  ];

  const settingsJoin = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    appendDots: (dots) => <ul className="custom-dots">{dots.slice(0, 3)}</ul>,
    customPaging: () => <div className="custom-dot" />,
    arrows: true,
  };

  return (
    <div className="join-section">
      <h1 className="heading-h1">Who Can Join?</h1>
      <Slider {...settingsJoin}>
        {data.map((item) => (
          <div key={item.id} className="join-card">
            <img src={item.img} alt={item.title} className="join-img" />
            <p>{item.title}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Join;
